import React, { FC, useMemo } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { buildArticleContent } from 'utils/knowledgeBaseContent'

interface Props {
  html: string
  className?: string
}

const useStyles = makeStyles((theme) => ({
  body: {
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
    '& h1, & h2, & h3': { scrollMarginTop: '104px' },
    '& img': { maxWidth: '100%', height: 'auto' },
    '& table': { borderCollapse: 'collapse', width: '100%' },
    '& th, & td': { border: `1px solid ${theme.palette.divider}`, padding: '0.4rem 0.6rem' },
    '& a': { color: theme.palette.primary.main },
  },
}))

const RichContent: FC<Props> = ({ html, className }) => {
  const s = useStyles()
  const history = useHistory()

  const content = useMemo(() => buildArticleContent(html), [html])

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const anchor = (event.target as HTMLElement).closest('a')
    if (!anchor) return
    const href = anchor.getAttribute('href') || ''
    let path: string | null = null
    if (href.startsWith('/')) path = href
    else if (href.startsWith(window.location.origin)) path = href.slice(window.location.origin.length)
    if (path) {
      event.preventDefault()
      history.push(path)
    }
  }

  return <Box className={`${s.body} ${className || ''}`} onClick={handleClick} dangerouslySetInnerHTML={{ __html: content.html }} />
}

export default RichContent
